import React from 'react';

import SvgIcon, { IProps } from '../SvgIcon';

export default (props: IProps) => (
  <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M3.34 17c-.42-.73-.75-1.51-.98-2.33a3 3 0 000-5.34 9.99 9.99 0 012.5-4.34A3 3 0 009.5 2.32a9.99 9.99 0 015 0 3 3 0 004.64 2.67 10 10 0 012.5 4.34 3 3 0 000 5.34 10 10 0 01-2.5 4.34 3 3 0 00-4.64 2.67 9.99 9.99 0 01-5 0 3 3 0 00-4.63-2.67c-.6-.6-1.1-1.28-1.53-2.01zm5.66.2a5 5 0 012.25 2.77c.5.04 1 .04 1.5 0a5 5 0 015.78-3.34c.29-.4.54-.84.74-1.3a5 5 0 010-6.66c-.2-.46-.46-.9-.75-1.3a5 5 0 01-5.77-3.34c-.5-.04-1-.04-1.5 0a5 5 0 01-5.77 3.34c-.3.4-.54.84-.75 1.3a5 5 0 010 6.66c.2.46.46.9.75 1.3A5 5 0 019 17.2z"/>
    <path fill="#34CEFF" fillRule="evenodd" d="M12 15a3 3 0 110-6 3 3 0 010 6zm.7-2.3a1 1 0 11-1.4-1.4 1 1 0 011.4 1.4z" clipRule="evenodd"/>
  </SvgIcon>
);